export const handleInternalUrlCheck = (url) => {
    return url.original_url.indexOf('cdc.gov') < 0 || url.original_url.indexOf('hhs.gov') < 0 || url.original_url.indexOf('atsdr.cdc.gov') < 0 || url.original_url.indexOf('emergency.cdc.gov') < 0 ? true : false;
}
